import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ProductView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";

type CreateProductInput = {
  storeSlug: string;
  nameAr: string;
  nameEn: string | null;
  shortDescriptionAr: string | null;
  shortDescriptionEn: string | null;
  categoryIds: string[];
  initialVariant: {
    price: number;
    discountedPrice: number | null;
    cost?: number | null;
    stockCount: number;
    forceOutOfStock: boolean;
  };
  isActive: boolean;
};

export function useCreateProductMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateProductInput) => {
      const { storeSlug, ...body } = input;
      void storeSlug;
      return apiJsonClient<ProductView>(endpoints.seller.products, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
